import React from 'react';
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";
import { Cog8ToothIcon } from '@heroicons/react/24/solid';

interface QuickSettingsProps {}

const QuickSettings: React.FC<QuickSettingsProps> = () => {
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { isMenuOpen } = dynamicStateObj;
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const userObj = useAppStore((state: any) => state.userObj);
    const { user } = userObj;

    // Return an empty div to maintain layout spacing when no user
    if (!user) {
        return <div className="h-6 w-6" />;
    }

    return (
        <button
            className={`h-6 w-6 cursor-pointer ${isMenuOpen ? "opacity-30" : ""}`}
            onClick={() => setDynamicStateObj({visiblePopup: "settings"})}
        >
            <Cog8ToothIcon className="h-6 w-6 text-neutral-700 dark:text-gray-200"/>
        </button>
    );
};

export default QuickSettings;